<template>
	<section class="newsletter">
		<div class="row align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
				<!-- Begin Mailchimp Signup Form -->
				<div id="mc_embed_signup">
					<form
						id="mc-embedded-subscribe-form"
						action="https://domupraesto.us14.list-manage.com/subscribe/post?u=0758ee83aa40dca587b11dff6&amp;id=d4ad7f7b6e&amp;f_id=007b87e0f0"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<div id="mc_embed_signup_scroll">
							<div class="mc-field-group newsletter-form">
								<input
									id="mce-EMAIL"
									type="email"
									value=""
									name="EMAIL"
									class="required email"
									:placeholder="$t('formEmail')"
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button"
									:value="button"
								/>
							</div>
							<div>
								<div id="mce-responses" class="clear">
									<div id="mce-error-response" class="response" style="display: none" />
									<div id="mce-success-response" class="response" style="display: none" />
								</div>
								<!-- real people should not fill this in - do not remove this or risk bot signups-->
								<div style="position: absolute; left: -5000px" aria-hidden="true">
									<input
										type="text"
										name="b_0758ee83aa40dca587b11dff6_d4ad7f7b6e"
										tabindex="-1"
										value=""
									/>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter {
	background: $cta-color;

	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
		background: #f2e6ce;
	}

	input:not(.button) {
		color: $body-color;
		border: none;
		width: 280px;
		padding: 0 10px;
		line-height: 50px;
		outline: none !important;
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
		background: $cta-color;
	}

	.row {
		max-width: 880px;
	}
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

section.newsletter,
.newsletter h2 {
	color: #fff;
}

section.newsletter {
	padding: 50px 0 0;
}

form.newsletter {
	border: 10px solid #fff;
	background: #f2e6ce;
	padding: 0 0 0 10px;
	display: inline-block;
	margin: 20px auto 50px;
	box-shadow: 0 24px 24px rgb(0 0 0 / 15%);
}

@media (max-width: 680px) {
	form.newsletter {
		padding: 0;
	}

	.newsletter input {
		width: 100%;
		text-align: center;
	}
}
</style>
